export default __webpack_public_path__ + "static/media/accountico.6afe94f9.svg";